import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = (state) => state.location || initialState;

const makeSelectLocationFilterMenuStatus = () =>
  createSelector(selectGlobal, (locationState) => locationState.locationFilterMenuStatus);

export { makeSelectLocationFilterMenuStatus };
